import { render, staticRenderFns } from "./courseRefund.vue?vue&type=template&id=68c1b6c8&scoped=true&"
import script from "./courseRefund.vue?vue&type=script&lang=js&"
export * from "./courseRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c1b6c8",
  null
  
)

export default component.exports